import React, { useCallback, useEffect } from "react";
import { Form, notification } from "antd";
import {
	useVerifyOtpMutation,
	useSendOtpMutation,
	useSendOtpToPhoneNumberMutation,
	useVerifyOtpAndChangePhoneNumberMutation,
} from "store/api/api";

import "./styles.scss";
import OTP from "./OTP";

const VerifyPhoneNumber = ({ user = {}, token, onContinue }) => {
	const [form] = Form.useForm();
	const [sendOtpToPhoneNumberTrigger, changePhone] = useSendOtpToPhoneNumberMutation();
	const [verifyChangeNumber, verifyOtpAndChangePhoneNumber] = useVerifyOtpAndChangePhoneNumberMutation();
	const [sendOtpTrigger, sendOtp] = useSendOtpMutation();
	const [verifyOtpTrigger, verifyOtp] = useVerifyOtpMutation();

	const sendOtpToUser = useCallback(
		async (userId) => {
			const payload = {
				user_id: userId,
			};
			try {
				await sendOtpTrigger(payload).unwrap();
			} catch (error) {
				notification.error({
					message: error?.data?.message || "Error sending OTP. Please try again later.",
				});
			}
		},
		[sendOtpTrigger]
	);
	useEffect(() => {
		if (user.id) {
			sendOtpToUser(user.id);
		}
	}, [sendOtpToUser, user.id]);

	function changePhoneNumber(values) {
		try {
			const newPhoneNumber = `+${form.getFieldValue("newPhoneNumber")?.countryCode}${
				form.getFieldValue("newPhoneNumber")?.areaCode
			}${form.getFieldValue("newPhoneNumber")?.phoneNumber}`;
			const payload = {
				new_phone_number: newPhoneNumber,
				code: values.otp,
			};
			verifyChangeNumber(payload).unwrap();
		} catch (error) {
			notification.error({
				message: error?.data?.message || "OTP is invalid. Please try again.",
			});
		}
	}

	const handleContinue = async (values) => {
		try {
			if (changePhone.data) {
				changePhoneNumber(values);
				notification.success({
					message: "Phone number changed successfully",
				});
			} else {
				const payload = {
					user_id: user.id,
					code: values.otp,
				};
				await verifyOtpTrigger(payload).unwrap();
				notification.success({ message: "Login Successful" });
			}
			onContinue?.({ user, auth_token: token });
		} catch (error) {
			notification.error({
				message: error?.data?.message || "OTP is invalid. Please try again.",
			});
		}
	};

	return (
		<OTP
			sendOtpToPhoneNumberTrigger={sendOtpToPhoneNumberTrigger}
			token={token}
			user={user}
			phoneNumber={user?.phone_number}
			changePhoneNumberButtonProps={{
				loading: changePhone.isLoading,
			}}
			hideChangeNumber
			resendOtpProps={{
				loading: sendOtp.isLoading,
				onClick: (e) => {
					e.preventDefault();
					if (user.id) {
						sendOtpToUser(user.id);
					} else {
						window.location.reload();
					}
				},
			}}
			continueButtonProps={{
				onClick: handleContinue,
				loading: verifyOtp.isLoading || verifyOtpAndChangePhoneNumber.isLoading,
				disabled: verifyOtp.isLoading || verifyOtpAndChangePhoneNumber.isLoading,
			}}
		/>
	);
};

export default VerifyPhoneNumber;

